// extracted by css-extract-rspack-plugin
export default {"root":"MX7rn","content":"IS4DN","alignRight":"g21xj","light":"p9Rfi","outline":"wjWPb","sortIndicator":"mq98A"};